module.exports = __webpack_public_path__ + "img/facebook.7290574c.svg";